var TotalViewLayout;!function(o){o[o.Layout1=0]="Layout1"}(TotalViewLayout||(TotalViewLayout={}));export{TotalViewLayout};
//# sourceMappingURL=types.js.map
